import React, { useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { Modal } from "react-responsive-modal";
import { kaReducer, Table } from "ka-table";
import { loadData, search, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import UpdateEOMDataService from "../services/eom-update-sevice";
import moment from "moment";

const UpdateEOMDataPage = ({ history }) => {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const onCloseModal = () => {
        setOpen(false);
    };

    const [fileContent, setFileContent] = useState({});
    const [month, setMonth] = useState();
    const [year, setYear] = useState(moment().format("YYYY"));
    const [selectMonthForUpload, setSelectMonthForUpload] = useState();
    const [selectYearForUpload, setSelectYearForUpload] = useState(moment().format("YYYY"));
    const [eomErrorData, setEOMErrorsData] = useState([]);


    const totalMonthsList = () => {
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        return months.map((i, index) => (
            <option value={index + 1} key={i}>
                {i}
            </option>
        ));
    };

    const handleUpload = async (event) => {
        try {
            setLoading(true);
            let formDataUrl = new FormData();
            formDataUrl.append("excel", fileContent);
            formDataUrl.append("enctype", "multipart/form-data");
            await UpdateEOMDataService.uploadUpdateEOMDocument(selectYearForUpload, selectMonthForUpload, formDataUrl);
            onCloseModal();
            setLoading(false);
            setFileContent({});
            setSelectYearForUpload(moment().format("YYYY"));
            setSelectMonthForUpload();
            const { hide } = cogoToast.success(
                "Document uploaded successfully.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        } catch (e) {
            const { hide } = cogoToast.error(
                "Error uploading document. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
    };

    const PAGE_SIZE = 10;
    const tablePropsInit = {
        columns: [
            { key: "fil_id", title: "Fill Id" },
            { key: "group", title: "Group" },
            { key: "packager", title: "Packager" },
            { key: "unique", title: "Unique" },
            { key: "qty", title: "Quantity" },
            { key: "amt_due", title: "Amount Due" },
            { key: "payor", title: "Payor" },
            { key: "Actions", title: "" },
        ],
        singleAction: loadData(),
        sortingMode: SortingMode.Single,
        rowKeyField: "id",
        search: ({ searchText, rowData, column }) => {
            if (column.key === "passed") {
                return (
                    (searchText === "false" && !rowData.passed) ||
                    (searchText === "true" && rowData.passed)
                );
            }
        },
        paging: {
            enabled: true,
            pageIndex: 0,
            pageSize: PAGE_SIZE,
            position: PagingPosition.Bottom,
        },
    };
    const [tableProps, changeTableProps] = useState(tablePropsInit);
    const dispatch = async (action) => {
        changeTableProps((prevState) => kaReducer(prevState, action));
        if (action.type === ActionType.LoadData) {
            dispatch(updateData([]));
        }
    };

    const getEOMUpdateErrors = async (currentMonth, isFromDelete) => {

        if (!currentMonth && !year) {
            const { hide } = cogoToast.error("Please select month and year", {
                hideAfter: 15,
                onClick: () => {
                    hide();
                },
            });

            return;
        }

        try {
            setLoading(true);
            const resp = await UpdateEOMDataService.fetchErrorEOMData(year, currentMonth);
            if ((!resp || resp.length <= 0) && !isFromDelete) {
                const { hide } = cogoToast.error("No data found for the specified criteria.", {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                });
                dispatch(updateData([]));
                setEOMErrorsData([]);
                return;
            }
            resp.sort(
                (d1, d2) => new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
            );
            dispatch(updateData(resp));
            setEOMErrorsData(resp);
        } catch (error) {
            const { hide } = cogoToast.error("Error getting results. Please try after sometime.", {
                hideAfter: 15,
                onClick: () => {
                    hide();
                },
            });
        } finally {
            setLoading(false);
        }
    };

    const [selectedId, setSelectedId] = useState("");
    const [deleteOpen, setDeleteOpen] = useState(false);
    const onDeleteCloseModal = () => {
        setDeleteOpen(false);
        setSelectedId("");
    };

    const CustomCell = ({ rowData }) => {
        return (
            <div className="action_btns">
                <span className="inline-block mx-4 cursor-pointer">
                    <img
                        src="./img/delete.svg"
                        className="m-auto w-4 h-4"
                        alt="delete"
                        title="Delete"
                        onClick={() => {
                            setSelectedId(rowData?.id);
                            setDeleteOpen(true);
                        }}
                    />
                </span>
            </div>
        );
    };

    const handleDeleteEOMErrors = async (id) => {
        try {
            const eomDeleted = await UpdateEOMDataService.deleteErrorsById(id);
            if (Object.keys(eomDeleted).length <= 0) {
                const { hide } = cogoToast.success("Error deleted successfully.", {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                });
            }
            await getEOMUpdateErrors(month, true);
        } catch (e) {
            const { hide } = cogoToast.error(
                "Error deleting EOM data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
    };

    const handleUpdateEOMErrors = async () => {
        try {
            const updatedData = await UpdateEOMDataService.updateEOMErrors(year, month);
            if (Object.keys(updatedData).length <= 0) {
                const { hide } = cogoToast.success("EOM Data Updated successfully.", {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                });
            }
        } catch (e) {
            const { hide } = cogoToast.error(
                "Error Updating EOM Data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
    };

    const handleDownloadEOMErrors = async () => {
        try {
            const { hide } = cogoToast.info(
                "Downloading is in progress. Please wait for sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            await UpdateEOMDataService.getEOMErrosDocument(year, month);
        } catch (e) {
            const { hide } = cogoToast.error(
                "Error downloading document. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        }
    }

    const totalYears = () => {
        const years = [];
        const dateStart = moment().subtract(1, "y");
        const dateEnd = moment().add(1, "y");
        while (dateEnd.diff(dateStart, "years") >= 0) {
            years.push(dateStart.format("YYYY"));
            dateStart.add(1, "year");
        }
        return years.map((i, index) => (
            <option value={i} key={i}>
                {i}
            </option>
        ));
    };

    return (
        <>
            <CipHeader />
            <div
                className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
                    }`}
            >
                <Loader
                    type="Oval"
                    color="#00BFFF"
                    height={50}
                    width={50}
                    timeout={300000} //3 secs
                />
            </div>
            <Modal open={deleteOpen} onClose={onDeleteCloseModal} center>
                <div className="pt-10 px-8 pb-4 ">
                    <h3
                        className="text-lg leading-6 font-medium text-gray-900 text-center"
                        id="modal-headline"
                    >
                        Are you sure you want to delete?
                    </h3>
                    <div className="flex justify-center">
                        <button
                            onClick={() => {
                                handleDeleteEOMErrors(selectedId);
                                setDeleteOpen(false);
                            }}
                            type="button"
                            className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                        >
                            Yes
                        </button>
                        <button
                            onClick={() => {
                                setDeleteOpen(false);
                            }}
                            type="button"
                            className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
                        >
                            Cancel
                        </button>

                    </div>
                </div>
            </Modal>
            <Modal open={open} onClose={onCloseModal} center>
                <div className=" px-4 pb-4 ">
                    <h3
                        className="text-lg leading-6 text-gray-900 text-labelclr font-semibold py-4 tracking-wider"
                        id="modal-headline"
                    >
                        Upload Document
                    </h3>
                    <div className="flex flex-col gap-4 justify-center w-full mt-4">
                        <select
                            name="list_month"
                            aria-label="Select Month"
                            value={selectMonthForUpload}
                            onChange={(e) => setSelectMonthForUpload(e.target.value)}
                            className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                        >
                            <option value="0">Select Month</option>
                            {totalMonthsList()}
                        </select>
                        <span>
                            <select
                                name="list_year"
                                aria-label="Select Year"
                                defaultValue={moment().format("YYYY")}
                                onChange={(e) => setSelectYearForUpload(e.target.value)}
                                className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                            >
                                {totalYears()}
                            </select>
                        </span>
                        <input
                            id="upload"
                            name="upload"
                            type="file"
                            onChange={(e) => {
                                setFileContent(e.target.files[0]);
                            }}
                            className="focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal "
                        />
                    </div>
                    <div className="flex justify-center">
                        <button
                            onClick={() => {
                                handleUpload();
                            }}
                            type="button"
                            disabled={
                                Object.getPrototypeOf(fileContent) === Object.prototype || loading
                            }
                            className={
                                Object.getPrototypeOf(fileContent) === Object.prototype || loading
                                    ? "opacity-50 cursor-not-allowed mr-4 rounded font-medium h-10 text-white w-auto px-4 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                                    : "mr-4 rounded font-medium h-10 text-white w-auto px-4 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                            }
                        >
                            Upload
                        </button>
                        <button
                            onClick={() => setOpen(false)}
                            type="button"
                            className="mr-2 rounded font-medium h-10 text-white w-auto px-6 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
            <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
                <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
                    <div className="w-1/3 text-darkclr font-semibold leading-10 ">
                        <span className="text-xl">Update EOM Data</span>
                    </div>
                    <div className="w-full sm:w-2/3 text-right">
                        <span className="mr-3">
                            <button
                                type="submit"
                                className="rounded font-medium h-10 text-white bg-login_btn mb-2 py-2 px-7 focus:outline-none text-sm"
                                aria-label="IMPORT"
                                onClick={() => setOpen(true)}
                            >
                                UPLOAD
                            </button>
                        </span>
                        <span className="relative">
                            <input
                                type="search"
                                defaultValue={tableProps.searchText}
                                onChange={(event) => {
                                    dispatch(search(event.currentTarget.value));
                                }}
                                placeholder=" Search"
                                disabled={!month}
                                className="border rounded w-5/12 mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom disabled:cursor-not-allowed disabled:opacity-60"
                            />
                            <img
                                src="/img/search-2.svg"
                                alt=""
                                className="absolute w-4 h-4 mb-2 right-5 top-2 bottom-3"
                            ></img>
                        </span>
                        <span className="mr-3">
                            <Link
                                to="/eomFiles"
                                className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
                            >
                                GO TO EOM FILES
                            </Link>
                        </span>
                    </div>
                </div>

                <div className="p-2 mt-4 flex flex-col md:flex-row justify-between items-center">
                    <div className="flex flex-col md:flex-row gap-4 justify-start w-4/5 h-auto items-center">
                        <select
                            name="list_month"
                            aria-label="Select Month"
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                            className="border focus:outline-none h-10 rounded-md text-sm font-normal w-full md:w-1/5"
                        >
                            <option value="0">Select Month</option>
                            {totalMonthsList()}
                        </select>
                        <select
                            name="list_year"
                            aria-label="Select Year"
                            defaultValue={moment().format("YYYY")}
                            onChange={(e) => setYear(e.target.value)}
                            className="border focus:outline-none h-10 rounded-md text-sm font-normal w-full md:w-1/5"
                        >
                            {totalYears()}
                        </select>
                        <button
                            disabled={loading}
                            onClick={() => {
                                getEOMUpdateErrors(month, false);
                            }}
                            className={
                                loading
                                    ? "opacity-50 cursor-not-allowed text-white w-full md:w-20 h-9 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                    : "text-white w-full md:w-20 h-9 cursor-pointer bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                            }
                        >
                            SUBMIT
                        </button>
                        <button
                            type="submit"
                            disabled={!month}
                            className={
                                !month
                                    ? "opacity-50 cursor-not-allowed text-white w-full md:w-24 h-9 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                    : "text-white w-full md:w-24 h-9 cursor-pointer bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                            }
                            aria-label="UPDATE"
                            onClick={() => handleDownloadEOMErrors()}
                        >
                            DOWNLOAD
                        </button>
                    </div>

                    <div className="flex justify-end w-4/5 md:w-1/5 h-auto items-center mt-4 md:mt-0">
                        <button
                            type="submit"
                            disabled={eomErrorData.length > 0 || !month}
                            className={
                                eomErrorData.length > 0 || !month
                                    ? "opacity-50 cursor-not-allowed text-white w-full md:w-20 h-9 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                    : "text-white w-full md:w-20 h-9 cursor-pointer bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                            }
                            aria-label="UPDATE"
                            onClick={() => handleUpdateEOMErrors()}
                        >
                            UPDATE
                        </button>
                    </div>
                </div>

                <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                        {...tableProps}
                        childComponents={{
                            cellText: {
                                content: (props) => {
                                    // eslint-disable-next-line default-case
                                    switch (props.column.key) {
                                        case "Actions":
                                            return <CustomCell {...props} />;
                                    }
                                },
                            },
                        }}
                        dispatch={dispatch}
                    />
                </div>
            </div>
        </>
    );
};

export default withRouter(
    connect(
        () => ({}),
        (dispatch) => {
            return bindActionCreators({}, dispatch);
        }
    )(UpdateEOMDataPage)
);
